// extracted by mini-css-extract-plugin
export var filterIncDec = "_a2-0";
export var leftBorder = "_a2-1";
export var rightBorder = "_a2-2";
export var stringInput = "_a2-3";